<template>
	<div class="alertBox" v-if="agreementShow">
		<div class="alertMask" @click="closeIt"></div>
		<div class="alertMain">
			<div class="alertBody">
                <div class="alertTitle">
                    <div class="tit">
                        <span style="color:white">《服务协议》</span>
                        <span class="closeIt" @click="closeIt"></span>
                    </div>
                </div>
                <div class="alertContent">
                      <h5>
                         尊敬的客户，欢迎注册成为“翰林征信”平台（www.hnhlcredit.com，以下简称本平台”）用户，在注册前请仔细阅读如下服务条款：
                       <h5> 
                           本平台由湖南翰林企业征信有限公司(以下简称“本公司”)运营管理，
                        并根据本协议的规定向用户提供服务。本协议双方为本平台用户与本公司，
                        适用于用户注册并使用本平台服务的全部活动。
                        </h5>
                    </h5>
                    <h5>
                        在注册本平台之前，请务必认真阅读并充分理解本协议全部内容。
                        注册程序完成时即视为用户已经充分理解和同意本协议全部内容，并签署了本协议，
                        本协议已在用户与本公司之间产生合同法律效力，用户使用本平台服务的全部活动将受到
                        本协议的约束并应承担相应的责任和义务。
                    </h5>
                    <strong>1、协议组成说明</strong>
                    <ul>
                        <li>1.1 本协议的内容包括本协议以下全部条款以及本平台已经公示发布的及将来
                            可能公示发布的各项规则，
                            均为本协议不可分割的一部分，与本协议以下所列条款具有同等法律效力。
                        </li>
                        <li>
                            1.2 本平台有权根据需要修改本协议的内容。如以下条款或本平台各项规则有任何变更，本平台将在平台上刊载公告，不
                            再向用户作个别通知。经修订的相关条款和规则一经公告，即于公告规定的特定生效日期自动生效。
                            请及时关注本平台关于相关条款和规则的公告，如不同意该变更，
                            请在变更公告刊载之日起72小时内以用户在本平台注册时提供的邮箱向本平台公布的服务邮箱
                            发送邮件或拨打客服电话表明希望终止本协议（"注册终止申请"），本平台确认收到邮件和电话后将与用
                            户协商本协议终止后双方义务的履行。如用户在本条所述时限内未发送注册终止申请，则本条所述时限届满之时，
                            视为用户已经同意接受该等变更，
                            并应遵照修改后的协议履行应尽义务，经修订的相关条款和规则一经公告，
                            即于公告规定的特定生效日期自动生效并对用户产生法律约束力。
                        </li>
                        <li>
                            1.3 本协议不涉及用户与本平台的其他用户之间因网上交易而产生的法律关系及法律纠纷。
                            但用户在此不可撤销地同意，将全面接受并履行与
                            本平台其他用户在本平台签订的任何电子法律文本，
                            并承诺按照该法律文本享有和（或）放弃相应的权利、承担和（或）豁免相应的义务。
                        </li>
                    </ul>
                    <strong>2、用户注册须知</strong>
                    <p>2.1 注册成为本平台用户必须满足如下相应主体资格条件：</p>
                    <ul>
                        <li>
                            （1） 用户年龄在 18 周岁以上，且具有完全的民事权利能力及民事行为能力；
                        </li>
                        <li>
                            （2） 您只能拥有一个本平台帐户；
                        </li>
                         <li>
                            （3） 本平台有根据法律法规或在合理状况下限制您使用“服务”
                        </li>
                    </ul>
                    <ul>
                        <li>
                            2.2 在注册和使用本平台服务期间，用户应根据本平台的要求提供自身的真实资料和信息，
                            并保证自注册之时起至使用本平台服务期间，其所提交的所有资料和信息
                            （包括但不限于真实姓名/名称、电子邮件地址、联系电话、身份信息等）真实、准确、
                            完整、有效和合法，扫描件与原件一致，如有变更，应及时更新，如因用户未及时更新信息和资料
                            导致本平台无法提供服务，由此产生的法律责任和后果由用户自担。如使用他人信息和文件注册使用本
                            平台服务或向本平台提供的信息和资料不符合上述规定，由此引起的一切责任和后果均由用户自担，本公司
                            及本平台不因此承担任何法律责任，如因此给本公司或本平台造成损失，用户应当承担赔偿责任。
                        </li>
                        <li>
                            2.3 用户帐号、密码及完成本服务的注册程序之后，
                            您将选择一个密码及帐号。维持密码及帐号的机密安全，是您的责任。
                            您应对所有用您的密码及帐号的活动负完全的责任。您同意∶
                        </li>
                        <li>
                            您的密码或帐号遭到未获授权的使用，
                            或者发生其他任何安全问题时，您将立即通知本平台；
                        </li>
                        <li>
                            一个账户在同一时间内仅能登录一台同一类型设备
                            （如您使用电脑登录，则同一账号同一时间仅能在一台电脑上登录，但您同时可以在手机上登录），
                            否则您将被迫下线而我们无需承担任何责任。用户使用时，不得存在连续、频繁的查询操作行为，
                            否则我们的后台将自动对您的账号封号且无需向您承担任何责任。用户每次使用完毕，
                            请安全退出把您的帐号关掉。如您未能依前述规定行事，对于任何人利用该密码及帐号及您不当操作
                            所进行的任何行为，您应负完全的责任。对于因此而产生的任何损失或损害，本平台不承担任何责任；
                        </li>
                        <li>
                            用户不得修改、改编、翻译我们的系列产品和服务，
                            或创作我们系列产品和服务的派生作品，或通过反编译、反向工程、
                            反汇编或其它方式从我们系列产品和服务中得到源代码。若用户存在上述情形，
                            则我们有权终止提供服务并要求保留向用户主张损失的权利。用户行为若涉嫌犯罪的，
                            将交由司法机关处理。
                        </li>
                    </ul>
                   
                    <p>
                        <strong>3、平台服务内容及服务费用</strong>
                    </p>
                    <ul>
                        <li>3.1 本平台向用户提供信息搜集、信息公布、资信评估、信息交互等服务。</li>
                        <li>3.2 用户使用本平台服务时，本公司有权收取服务费用，
                            具体服务费用收取标准以本平台公告或者本公司与用户另行签订的相关协议为准。
                            用户在此不可撤销地承诺，将按照用户签署的相关协议约定向本公司支付服务费用。
                            用户通过本平台与其他方签订协议的，应按照签署的协议约定向其他方支付费用，如发生任何纠纷，
                            与本平台无关。
                        </li>
                        <li>
                            3.3您同意，基于运行和交易安全的需要，本公司可以暂时停止提供或者限制本服务部分功能，
                            或提供新的功能，在任何功能减少、增加或者变化时，只要您仍然使用本服务，表示您仍然同意本协议或者变更后的协议。
                        </li>
                    </ul>
                    <span>
                        <strong>
                            4、用户使用规则
                        </strong>
                    </span>
                    <p>
                        4.1 用户不得利用本平台或本平台服务从事任何不符合中国法律法规或侵犯他人权益的活动。不得自行发布、转载
                        、传送含有下列内容之一的信息，本平台在发现用户从事该等活动或发布信息时，有权基于本平台的独立判断直接
                        删除用户在本平台上作出的相关信息，有权不经通知而立即停止用户对本平台的全部或部分功能的使用（包括但不限于中止、
                        终止、限制用户使用本平台服务）而无需通知用户，亦无需承担任何责任。如因此给本公司或本平台造成损失的，应当赔偿损失。
                    </p>
                    <ul>
                        <li>（1） 违反宪法确定的基本原则的；</li>
                        <li>（2） 危害国家安全，泄露国家机密，颠覆国家政权，破坏国家统一的；</li>
                        <li>（3） 损害国家荣誉和利益的；</li>
                        <li>（4） 煽动民族仇恨、民族歧视，破坏民族团结的；</li>
                        <li>（5） 破坏国家宗教政策，宣扬邪教和封建迷信的；</li>
                        <li>（6） 散布谣言，扰乱社会秩序，破坏社会稳定的；</li>
                        <li>（7） 散布淫秽、色情、赌博、暴力、恐怖或者教唆犯罪的；</li>
                        <li>（8） 侮辱或者诽谤他人，侵害他人合法权益的；</li>
                        <li>（9） 煽动非法集会、结社、游行、示威、聚众扰乱社会秩序的；</li>
                        <li>（10） 以非法民间组织名义活动的；</li>
                        <li>（11） 含有法律、行政法规禁止的其他内容的。</li>
                    </ul>
                    <p>4.2 在使用本平台时，用户不得违反下述规定，如违反任意一条，本平台有权基于独立判断直接删除用
                        户在本平台上作出的相关信息，有权要求用户改正或直接采取必要的措施禁止（包括但不限于中止、终止、限制用户使用本平台服务）
                        而无需通知用户，亦无需承担任何责任。如因此给本公司及本平台造成损失的，用户应当赔偿本公司及本平台的损失。
                    </p>
                    <ul>
                        <li>（1） 不得为任何非法目的而使用网络服务系统；</li>
                        <li>（2） 遵守所有与网络服务有关的网络协议、规定和程序；</li>
                        <li>（3） 不得利用本平台进行任何可能对互联网的正常运转造成不利影响的行为；</li>
                        <li>（4） 不得利用本平台进行任何不利于本平台或侵犯本公司利益的行为或言论。</li>
                    </ul>
                    <p>4.3 账户安全及管理：</p>
                    <ul>
                        <li>
                            4.3.1 用户在注册时向本平台提交的电子邮箱、用户名、
                            密码及安全问题答案是用户在本平台的唯一识别信息。用户注册成功后，
                            应当妥善保管用户名和密码，并对自己的用户名、密码安全性负责，不得将注册的电子邮箱、
                            用户名、密码及安全问题答案转让、赠与或授权给第三方使用。用户确认使用用户名和密码
                            登陆本平台后在本平台的一切行为以及以用户在本平台注册时提交的电子邮箱发送邮件的行为均为
                            用户本人操作，并承担相应的法律后果，本公司及本平台不承担任何责任。
                        </li>
                        <li>
                            4.3.2 协助义务：用户如发现有第三人冒用或盗用用户账户及密码，或其他任何未经合法授权的情形，
                            应立即以有效方式通知本平台，要求本平台暂停相关服务，否则由此产生的一切责任由用户自担。同时，
                            用户理解并同意本平台对其提出的请求采取行动需要合理期限，在此之前，本平台对第三人使用该服务
                            所导致的损失不承担任何责任。
                        </li>
                        <li>
                            4.3.3 本平台有权基于单方独立判断，在其认为可能发生危害交易安全等情形时，
                            不经通知而先行暂停、中断或终止向用户提供本协议项下的全部或部分服务（包括收费服务），
                            并将注册资料移除或删除，且无需对用户或任何第三方承担任何责任。前述情形包括但不限于：
                        </li>
                    </ul>
                   
                    <ul>
                        <li>（1） 本平台认为用户提供的相关资料不具有真实性、有效性或完整性；</li>
                        <li>（2） 本平台发现异常交易或有疑义或有违法之虞时；</li>
                        <li>（3） 本平台认为用户的账户涉嫌洗钱、套现、传销、被冒用或其他本平台认为有风险之情形；</li>
                        <li>（4） 本平台认为用户已经违反本协议中规定的各类规则及精神；</li>
                        <li>（5） 用户在使用本平台收费服务时未按规定向本公司支付相应的服务费用；</li>
                        <li>（6） 用户账户已连续12月内未实际使用且账户中余额为零；</li>
                        <li>（7） 本平台基于交易安全等原因，根据其单独判断需先行暂停、
                                  中断或终止向用户提供本协议项下的全部或部分用户服务（包括收费服务），
                                  并将注册资料移除或删除的其他情形。
                        </li>
                    </ul>
                    <ul>
                        <li>
                            4.3.5 用户同意，账户的暂停、中断或终止不代表用户责任的终止
                            ，用户仍应对使用本平台服务期间的行为承担可能的违约或损害赔偿责任，同时本平台仍可保有用户的相关信息。
                        </li>
                        <li>4.3.5 用户同意，账户的暂停、中断或终止不代表用户责任的终止，
                            用户仍应对使用本平台服务期间的行为承担可能的违约或损害赔偿责任，同时本平台仍可保有用户的相关信息。</li>
                        <li>4.4 知识产权：</li>
                        <li>4.4.1 本平台的所有内容，包括但不限于文本、数据、图片、音频、视频、源代码和其他所有信息，均由本公司及本平台享有知识产权。未经本平台事先书面同意，不得复制、模仿、改编、传播、公布、展示或以任何其他方式侵犯本平台的知识产权。未经本公司书面同意,用户不得将本平台包含的资料等任何内容发布到任何其他平台或者服务器。任何未经授权对本平台内容的使用均属于违法行为，
                            本公司有权追究法律责任。注册用户未经本平台的明确书面同意不许下载（除了页面缓存）
                            或修改平台或其任何部分。
                        </li>
                        <li>
                            4.4.2 用户不得对本平台或其内容进行转售或商业利用；不得收集和利用产品目录、说明和价格；
                            不得对本平台或其内容进行任何衍生利用；不得为其他商业利益而下载或拷贝账户信息或使用任何数据采集、收集和摘录工具。未经本平台的书面许可，严禁对本平台的内容进行系统获取以直接或间接创建或编辑文集、汇编、数据库或人名地址录
                            （无论是否通过Robots、Spiders、自动仪器或手工操作）。
                            另外，严禁为任何未经本协议明确允许的目的而使用本平台上的内容和材料。
                        </li>
                    </ul>
                    <p>
                        <strong>5、用户隐私保护及授权</strong>
                    </p>
                    <ul>
                        <li>5.1 用户同意本平台在业务运营中收集和储存用户信息，包括但不限于用户自行提供的资料和信息，以及本平台自行收集、
                            取得的用户在本平台的交易记录和使用信息等。
                            本平台收集和储存用户信息的主要目的在于提高服务的效率和质量。
                        </li>
                        <li>5.2 本平台不对外公开或第三方提供单个用户的注册资料及用户在使用网络服务时存储在本平台的非公开内容，但下列情况除外：</li>
                    </ul>
                    <ul>
                        <li>（1） 事先获得用户的明确授权；</li>
                        <li>（2） 根据有关的法律法规要求；</li>
                        <li>（3） 按照相关政府主管部门的要求；</li>
                        <li>（4） 为维护社会公众的利益。</li>
                    </ul>
                    <ul>
                        <li>
                            5.3 本平台可能会与第三方合作向用户提供相关的网络服务，在此情况下，
                            如该第三方同意承担与本站同等的保护用户隐私的责任，则本站有权将用户的注册资料等提供给该第三方。
                        </li>
                        <li>
                            5.4 本平台按照用户在本平台上的行为自动追踪关于用户的某些资料。
                            在不透露注册用户的隐私资料的前提下，本平台有权对整个用户数据库进行分析并对用户
                            数据库进行商业上的利用。
                        </li>
                        <li>
                            5.5 用户同意，本公司及本平台可在本平台的某些网页上使用数据收集装置。
                        </li>
                        <li>
                            5.6 用户同意，使用本平台的个人用户，一旦接受企业用户的邀请后，
                            本平台即认为该个人用户同意该企业用户对该个人用户进行职业背景调查。
                        </li>
                    </ul>
                    <p>
                        <strong>6、责任限制</strong>
                    </p>
                    <ul>
                        <li>6.1 基于互联网的特殊性，本公司无法保证本平台的服务不会中断，对于包括但不限于本公司、
                            本平台及相关第三方的设备、系统存在缺陷，计算机发生故障、遭到病毒、黑客攻击或者发生地震、
                            海啸等不可抗力而造成服务中断或因此给用户造成的损失，本公司不承担任何责任，有关损失由用户自担。
                        </li>
                        <li>
                            6.2 本公司无义务监测本平台内容。用户对于本平台披露的信息、选择使用本平台提供的服务，选择参与交易等，
                            应当自行判断真实性和承担风险，由此而产生的法律责任和后果由用户自担，本公司不承担任何责任。
                        </li>
                        <li>
                            6.3 与本公司合作的第三方机构向用户提供的服务由第三方机构自行负责，本公司不对此等服务承担任何责任。
                        </li>
                        <li>
                            6.4 本平台的内容可能涉及第三方所有的信息或第三方平台，该等信息或第三方平台的真实性、可靠性、
                            有效性等由相关第三方负责，用户对该等信息或第三方平台自行判断并承担风险，与本平台和本公司无关。
                        </li>
                        <li>6.5 无论如何，本公司对用户承担的违约赔偿（如有）总额不超过向用户收取的服务费用总额。</li>
                    </ul>
                    <p>
                        <strong>7、风险提示</strong>
                    </p>
                    <p>
                        7.1 用户了解并认可，任何通过本平台进行的交易并不能避免以下风险的产生，本平台不能也没有义务为如下风险负责：
                    </p>
                    <ul>
                        <li>（1） 宏观经济风险：因宏观经济形势变化，可能引起价格等方面的异常波动，用户有可能遭受损失；</li>
                        <li>（2） 政策风险：有关法律、法规及相关政策、规则发生变化，可能引起的一些方面异常波动，用户有可能遭受损失；</li>
                        <li>（3） 违约风险：因其他交易方无力或无意愿按时足额履约，用户有可能遭受损失；</li>
                        <li>（4） 不可抗力因素导致的风险；</li>
                        <li>（5） 因用户的过错导致的任何损失 ，该过错包括但不限于：操作不当、遗忘或泄露密码、
                            密码被他人破解、用户使用的计算机系统被第三方侵入、用户委托他人代理操作时他人恶意或不当操
                            作而造成的损失。
                        </li>
                    </ul>
                    <ul>
                        <li>
                            7.2 除按照规则运作外，本平台不对任何用户及/或任何交易提供任何担保或条件，
                            无论是明示、默示或法定的。本平台不能也不试图对用户发布的信息进行控制，
                            对该等信息，本平台不承担任何形式的证明、鉴定服务。本平台不能完全保证平台内容的真实性、
                            充分性、可靠性、准确性、完整性和有效性，并且无需承担任何由此引起的法律责任。用户依赖于用户的
                            独立判断进行交易，用户应对其作出的判断承担全部责任。
                        </li>
                        <li>
                            7.3 以上并不能揭示用户通过本平台进行操作的全部风险及市场的全部情形。
                            用户在做出决策前，应全面了解相关交易，谨慎决策，并自行承担全部风险。
                        </li>
                        <li>
                            7.4 您经由本平台之使用下载或取得任何资料，
                            应由您自行考量且自负风险，因资料之下载而导致您电脑系统之任何损坏或资料流失，您应负完全责任。
                        </li>
                        <li>
                            7.5 您自本公司及本公司工作人员或经由本平台取得之建议和资讯，无论其为书面或口头形式，均不构成本公司对本平台服务之保证。
                        </li>
                    </ul>
                    <p>
                        <strong>8.电子合约签署</strong>
                    </p>
                    <p>包含上述7项，您还保证以下几点</p>
                    <ul>
                        <li>
                            8.1 您保证，在您同意接受本协议并注册成为本平台用户时，
                            即表示您认可使用本平台电子合约签署作为缔约（包括但不限于电子合同）方式，
                            认可您本平台上的所有操作都是您个人意愿的表示，认可您在本平台上签订的电子合同（或协议）
                            和纸质合同（或协议）具备相同的效力，认可您在本平台上的电子签名和您的手写签名具备相同的效力。
                        </li>
                        <li>
                            8.2 您同意，就您使用本平台电子合约签署服务，本公司有权将您的个人身份信息及签约合同
                            信息相应传输至电子商务认证授权机构（CA, Certificate Authority）或公证处，
                            由CA以出具数字证书之目的或公证处以出具公证文件之目的使用并保存，且前述信息至少保
                            存至数字证书失效后或相关电子数据（包括但不限于签约合同电子数据）产生后5年，并且该
                            等信息不因您终止本平台服务而停止保存。
                        </li>
                        <li>
                            8.3 您同意，就您使用本平台电子签署服务，本公司有权将您的个人身份信息、证件复印件或
                            扫描件相应传输至征信机构及其他具有国家认可
                            资质的数据服务提供商，由该等机构以验证签约方身份之目的使用并保存。
                        </li>
                        <li>
                            8.4 您确认并知悉，本平台电子合约签署服务不适用于以下合同：
                        </li>
                    </ul>
                    <ul>
                        <li>（1）、涉及婚姻、收养、继承等人身关系的；</li>
                        <li>（2）、涉及土地、房屋等不动产权益转让的；</li>
                        <li>（3）、涉及停止供水、供热、供气、供电等公用事业服务的；</li>
                        <li>（4）、法律、行政法规规定的不适用电子文书的其他情形。</li>
                    </ul>
                    <p>
                        8.5 您理解并同意，如（a）您连续12个月未使用您的电子合约；或（b）您在本平台有欺诈、虚假交易、
                        侵犯他人合法权益或其他严重违反本平台 规则或者中华人民共和国法律的行为的，本公司有权注销您名下的
                        全部本平台登录名，您将不能再登录本平台网站，所有网站的服务将同时终止。
                    </p>
                    <p>8.6.电子合约签署服务</p>
                    <ul>
                        <li>8.6.1本平台电子合约签署服务（以下简称为本服务）：
                            指本条8.6.2所列的服务，及您实际使用的本公司或本公司接
                            受您的委托为您不时提供的服务以及提供的其他服务。
                        </li>
                        <li>8.6.2 本服务包括（但不限于）以下服务：</li>
                        <li>电子协议服务</li>
                        <li>通过本平台，本公司向注册用户提供在该平台上的电子协议发送，签署，接受，打印等服务。</li>
                        <li>电子证据保存和公证服务</li>
                        <li>
                            本公司通过指定合作方公司提供所有在本平台上的电子交易证据保存服务和公证服务。
                            若用户需要对交易过程中产生的协议进行公证，可以通过本平台提出 
                            申请，并和指定合作公司和公证机构签订协议（若需要），并支付指定公司及公证机构相关的服务费用。
                        </li>
                    </ul>
                    <p>8.7电子合约签署服务使用规则</p>
                    <p>为有效保障您使用本服务时的合法权益，您理解并同意接受以下规则：</p>
                    <ul>
                        <li>
                            8.7.1一旦您使用本服务，您即不可撤销地授权本公司在您及
                            （或）您指定人符合指定条件或状态时，向您的合作伙伴发送签约邀请并执行对应的操作。
                        </li>
                        <li>
                            8.7.2本公司通过以下方式接受来自您的指令：
                         </li>
                         <li>A、您在本网站通过以您的本平台账户名及密码登录并依照本服务预设流程所修改或确认
                               的交易状态或指令；
                            </li> 
                            <li>
                                B、您通过您注册时作为该账户名称或者与该账户绑定的手机或其他专属于
                               您的通讯工具（以下合称 该手机）号码向本公司发送的信息（短信或电话等）回复；
                            </li>
                            <li>
                                C、您通过您注
                                册时作为该账户名称或者与该账户名称绑定的其他硬件、终端、软件、代号、编码、代 码、其他账户名
                                等有形体或无形体向本公司发送的信息（如本方式所指有形体或无形体具备与该手机接受信息相同或
                                类似的功能；
                            </li> 
                            <li>D、通过识别您的指纹等生物特征；</li>
                            <li>
                                E、本公司与您约定或本公司认可的其他方式。无论您通 
                            过以上何种方式向本公司发出指令，都不可撤回或撤销，且成为本公司代理您支付或收取款项或进行
                            其他操作的唯一指令，视为您本人的指令，您应当自己对本公司忠实执行上述指令产生的任何结果承担责任。
                            本协议所称绑定，指您的账户与本条上述所称有形体或无形体存在对应的关联关系，这种关联关系使得
                            平台电子签署服务的某些服务功能得以实现，且这种关联关系有时使得这些有形体或无形体能够作为本公
                            司对您的平台电子签署账户的识别和认定依据。
                            </li>
                        <li>8.7.3您确认，您在网站上的任何操作以及因为操作导致的结果都具备法律效力。</li>
                        <li>本服务即表示您同意接受本服务的相关规则。您了解并同意本公司有权单方修改服务的相关规则，
                            而无须征得您的同意，服务规则应以您使用服务时的页面提示（或 发送到该手机的短信或电话
                            或客户端通知等）为准，您同意并遵照服务规则是您使用本服务的前提。
                        </li>
                        <li>
                            8.7.4 本公司会以站内状态通知（或发送短信到该手机或电话、客户端通知等）方式通知您交易进展情况以及提示您
                            进行下一步的操作，但本公司不保证您能够收到或者及时收到该等通知，且不对此承担任何后果，因此，您应当
                            及时查看该等通知并进行相关操作。因您没有及时查看和对交易状态进行修改或确认或未能提交相关申请而导致的任何纠纷或损失，
                            本公司不负任何责任。
                        </li>
                        <li>
                            8.7.5 本公司对您所交易的协议内容不提供任何形式的鉴定服务。
                            除本协议另有规定外，如您与交易对方发生交易纠纷，您不可撤销地授权由本公司根
                            据本协议及本网站上载明的各项规则进行处理。您为解决纠纷而支出的通讯费、文件复印费、
                            鉴定费等均由您自行承担。因市场因素致使而使任何一方得益或者受到损失而产生的纠纷本公司不予处理。
                        </li>
                        <li>8.7.6 您应按照本公司的要求完善您的身份信息以最终达到实名，否则您可能会受到部分功能限制。</li>
                        <li>
                            8.7.7 本公司会将您的交易过程及产生的资料，严格按照法律法规或有权机关的监管要求进行管理；
                            除本协议另有规定外，不作任何其他非您指示的用途。就您使用本平台电子签署服务，
                            本公司有权将您的个人身份信息及签约合同信息相应传输至电子商务认证授权机构
                            （CA, Certificate Authority）或公证处，由CA以出具数字证书之目的或公证处以出具公证文件之
                            目的使用并保存，且前述信息至少保存至数字证书失效后或相关电子数据（包括但不限于签约合同电子数据）
                            产生后5年，并且该等信息不因您终止电子签署服务而停止保存。同时，本公司有权将您的个人身份信息、
                            证件复印件或扫描件相应传输至征信机构及其他具有国家认可资质的数据服务提供商，由该等机构以验证签约
                            方身份之目的使用并保存。
                        </li>
                        <li>
                            8.7.8 本公司并非法律机构，因交易内容或者因为协议内容产生的纠纷，
                            本公司不承担任何解决义务，您可以向符合中华人民共和国法律规定的相关单位寻求解决。
                        </li>
                        <li>8.7.9 您不得将本服务用于非本公司许可的其他用途。</li>
                        <li>8.8 签约风险</li>
                        <li>8.8.1 在使用本服务时，若您或您的签约对方未遵从本服务条款或网站说明、交易页面中之操作提示、规则，
                            则本公司有权拒绝为您与签约对方提供相关服务，且本公司不承担损害赔偿责任。
                        </li>
                        <li>8.8.2 因您的过错导致的任何损失由您自行承担，该过错包括但不限于：不按照提示操作，
                            未及时进行操作，遗忘或泄漏密码、校验码等， 密码被他人破解，您使用的计算机或其他硬件、
                            终端等被他人侵入或丢失，或您使用的软件被他人侵入，或者您的生物特征被他人利用。
                        </li>
                    </ul>
                    <p>
                        <strong>9. 数据来源与责任限制</strong>
                    </p>
                    <p>9.1 根据用户指令，本平台的搜索引擎系统会以非人工检索方式生成用户检索的已经依法公开的企业信息。
                        目前本平台数据来源主要包括：
                    </p>
                    <ul>
                        <li><a href="http://www.gsxt.gov.cn/">国家企业信用信息公示系统（http://www.gsxt.gov.cn/）</a></li>
                        <li><a href="https://wenshu.court.gov.cn/">中国裁判文书网（https://wenshu.court.gov.cn/）</a></li>
                        <li><a href="http://zxgk.court.gov.cn/">中国执行信息公开网（http://zxgk.court.gov.cn/）</a></li>
                        <li><a href="http://www.cnipa.gov.cn/">国家知识产权局官方网站（http://www.cnipa.gov.cn/）</a></li>
                        <li><a href="http://sbj.cnipa.gov.cn/">国家知识产权局商标局中国商标网（http://sbj.cnipa.gov.cn/）</a></li>
                        <li><a href="http://www.ncac.gov.cn">国家版权局官方网站（http://www.ncac.gov.cn）</a></li>
                    </ul>
                    <p>
                        <strong style="font-size:18px;font-weight:bold">  
                              本平台所登载的信息均来自于网络公开信息，本平台仅对相关网站依法公示的信
                            息向用户如实展示， 并不主动编辑或修改被所公示网站上的信息的内容或其表现形式。
                            受限于现有技术水平、各信息来源网站更新不同步等原因， 对此类信息的展示，并不视为本平
                            台对其内容的真实性、准确性、完整性、时效性作出任何形式的确认或担保。 请您在依据本平台服务
                            相关信息作出判断或决策前，自行进一步核实此类信息的完整或准确性，并自行承担使用后果。 同时，
                            本平台承诺将不断提升技术水平，逐步完善服务信息来源质量与更新频次，为您提供更高质量的服务。
                        </strong>
                    </p>
                    <p>
                        9.2 由于政府禁令、现行生效的适用法律或法规的变更、火灾、地震、瘟疫、战争、停电、
                        通讯线路中断、电信部门技术调整、 因政府管制而造成网站的暂时性关闭等其他任何影响网络正常运营的不可预见、
                        不可避免、不可克服和不可控制的事件（<strong style="font-size:18px;font-weight:bold">“不可抗力事件”</strong>）； 以及他人蓄意破坏，黑客攻击、计算机病毒，系统维护、
                        系统升级， 网络过载等技术问题（<strong style="font-size:18px;font-weight:bold">“技术事件”</strong>）而导致本网站不能访问而造成的本站所提供的信息及数据的延误、
                        停滞或错误，本平台无须承担责任。 同时，本平台承诺将不断完善技术设施与条件，尽最大努力避免技术事件的发生，
                        在不可抗力事件或技术事件发生时， 在条件允许的前提下尽最大努力修复，以确保您继续正常使用，最大程度地避免您的损失。
                    </p>
                    <p>
                        9.3 请您知悉并同意，由于本平台服务的互联网服务性质， 
                        因此在服务的各个环节中不可避免地会受到相关不确定因素的影响（如电信运营商、网络质量、
                        您使用的设备型号及系统、您的地理位置等）， 由于前述不确定因素造成您无法正常使用本平台服务的，
                        本平台无须承担任何责任。同时，本平台承诺将在技术条件允许范围内尽最大努力为您解决， 
                        以确保您能够正常使用。
                    </p>
                    <p>
                        9.4 当您通过移动智能设备应用端使用本平台服务时， 请您知悉，我们针对不同品牌、
                        不同型号的终端设备，开发了不同的移动应用程序版本， 请您根据实际情况选择合适的版本进行下载及安装
                        。如果由于您本平台之外的原因， 导致您未能安装正确、对应的版本，我们无法保证该版本移动应用程序能够
                        正常使用，并对因此给您造成的损失不予负责。 
                    </p>
                    <p>
                        <strong>10、其他</strong>
                    </p>
                    <ul>
                        <li>10.1 本协议的订立、执行、解释及争议解决均适用中华人民共和国法律（不包括香港、澳门、台湾地区）。
                            本协议条款具有可分性，部分无效不影响其它部分效力。本平台对本协议拥有最终的解释权。
                        </li>
                        <li>10.2 如果你是本平台注册用户，本协议条款将对用户持续有效，有效期至用户注销或者被关闭账户后。</li>
                        <li>10.3 如有任何争议，应友好协商解决，协商不成，应提交本公司所在地有管辖权的法院诉讼解决。</li>
                    </ul>
                </div>
                
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'agreement',
		components: {},
		props: {
		},
		data() {
			return {
                agreementShow: false
			}
		},
		created() {},
		methods: {
            closeIt() {
				this.agreementShow = false
			},
		},
		mounted() {}
	}
</script>
<style lang="scss" scoped>
.alertBox{
    border-radius: 50%;
    .alertMain{
      width: 40%;
      .alertContent{
          overflow-y:auto;
          position:absolute;
          height:560px;
          padding: 20px;
          h5{
              font-size: 16px;
              color: #666;
          }
          ul{
               font-size: 16px;
              color: #666;
          }
          strong{
              color: black;
              font-size: 20px;
          }
          p{
              font-size: 16px;
              color: #666;
          }
      }
  }
}
  
</style>

